import { collection, getDocs } from 'firebase/firestore';
import { db } from './firebase';
import { AppUser, UserRole, UserLanguage } from '../types';
import { updateUserRole } from './userService';
import { logAuditEvent } from './auditService';

export async function getAllUsers(): Promise<AppUser[]> {
  const snap = await getDocs(collection(db, 'users'));
  return snap.docs
    .map(d => {
      const data = d.data();
      return {
        uid: data.uid,
        email: data.email,
        firstname: data.firstname,
        lastname: data.lastname,
        role: data.role as UserRole,
        language: (data.language as UserLanguage) ?? 'pl',
        createdAt: data.createdAt?.toDate?.() ?? new Date(),
        updatedAt: data.updatedAt?.toDate?.() ?? new Date(),
        lastLoginAt: data.lastLoginAt?.toDate?.() ?? undefined,
      };
    })
    .sort((a, b) => (a.email ?? '').localeCompare(b.email ?? ''));
}

async function updateUserRoleWithAudit(uid: string, role: UserRole, previousRole?: UserRole): Promise<void> {
  await updateUserRole(uid, role);
  logAuditEvent({
    entityType: 'user',
    entityId: uid,
    action: 'update',
    details: `role → ${role}`,
    previousValues: previousRole !== undefined ? { role: previousRole } : undefined,
    newValues: { role },
  }).catch(() => {});
}

export { updateUserRoleWithAudit as updateUserRole };
